export type SubscriptionTier = "free" | "premium" | "advance" | "standard";
export type SubscriptionPaymentCycle = "year" | "month" | "lifetime";
export type StripeSubscriptionPaymentCycle = "annual" | "monthly"; // this was the original value
export type AvailableSubscription = "premiumAnnual" | "premiumMonthly" | "free";
export const AvailableSubscriptionList = ["premiumAnnual", "premiumMonthly"];
export type SubscriptionPaymentProvider = "ironfly" | "stripe" | "apple";

export interface PlanOption {
  subscriptionTier: SubscriptionTier;
  subscriptionPaymentCycle: SubscriptionPaymentCycle;
  label: string; // use i18n key
  fee?: string;
  feeAmount?: string; // e.g., "AUD 2.31"
  paymentCycle?: string; // e.g., "/week"
  feeDesc?: string;
  labelType?: "text" | "icon";
  subscriptionId?: string;
  youSave?: string;
}

export const YEAR = "year";
export const MONTH = "month";
export const LIFETIME = "lifetime";
export const FREE = "free";
// Free-trial length by billing cycle (days).
export const ANNUAL_TRIAL_DAYS = 14;
export const MONTHLY_TRIAL_DAYS = 14;
export const AvailablePaymentCycles = [YEAR, MONTH] as const;
export const AvailableTiers = ["free", "premium", "advance", "standard"] as const;

export const PlanOptions: Record<AvailableSubscription, PlanOption> = {
  premiumAnnual: {
    subscriptionTier: "premium",
    subscriptionPaymentCycle: YEAR,
    label: "annually", // use i18n key
    fee: "AUD 2.31/week",
    feeAmount: "AUD 119.88", // todo: maybe remove
    paymentCycle: "/year",
    feeDesc: "AUD 119.88, billed annually", // todo: maybe remove
    labelType: "text",
    youSave: "34%",
  },
  premiumMonthly: {
    subscriptionTier: "premium",
    subscriptionPaymentCycle: MONTH,
    label: "monthly", // use i18n key
    fee: "AUD 14.99/month", // todo: maybe remove
    feeAmount: "AUD 14.99",
    paymentCycle: "/month",
    labelType: "text",
    feeDesc: "AUD 14.99, billed monthly", // todo: maybe remove
  },
  free: {
    subscriptionTier: FREE,
    subscriptionPaymentCycle: LIFETIME,
    label: FREE, // use i18n key
  },
};
